import { GetOptionsForUserLoginResponseBody } from '../types/generated/configuration_get.response';
import apiEndpoints from '../../apiEndpoints';
import { fetcher } from '../utils/fetchers/fetcher';

export const requestConfig = (
  token: string | null
): Promise<GetOptionsForUserLoginResponseBody> =>
  fetcher<GetOptionsForUserLoginResponseBody>(
    apiEndpoints.routes.userConfig,
    'GET',
    token
  );
